import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.application-info', {
        url: '/application/info/:appTypeId',
        component: 'companyApplicationInfo',
        params: {
        	appPermissions: {sra:false},
    },
        resolve: {
            $breadcrumbs,
            appType,
            appTypeId,
            appPermissions,
        }
    });
}

/** @ngInject */
function $breadcrumbs(appType) {
    const title = appType.applicationTypeDisplayName;
    return [{stateName: 'company.supported-application-types'}, {title}];
}

/** @ngInject */
function appType(appTypeId, appType$) {
    return appType$(appTypeId).get();
}

/** @ngInject */
function appTypeId($stateParams) {
    return $stateParams.appTypeId;
}

/** @ngInject */
function appPermissions($stateParams) {
	return $stateParams.appPermissions;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/application-info/application-info.state.js